<app-topstrip></app-topstrip>

<div class="error-container">
  <mat-card class="cardWithShadow error-card text-center">
    <mat-card-content>

      <div class="spinner-container">
        <mat-progress-spinner
          [value]="(5 - countdown) * 20"
          mode="determinate"
          color="warn"
          diameter="80"
        ></mat-progress-spinner>
        <div class="spinner-text">{{ countdown }}</div>
      </div>


      <h1 class="error-title">
        {{ type === 'unauthorized' ? 'Unauthorized Access' : '404 Page Not Found' }}
      </h1>
      <p class="error-subtitle">
        {{ type === 'unauthorized'
        ? 'You do not have permission to access this page.'
        : 'The page you are looking for does not exist.' }}
      </p>
      @if (countdown > 0) {
        <p class="redirect-info">
          Redirecting in {{ countdown }} seconds...
        </p>
      }
      <button mat-raised-button color="primary" (click)="goHome()" class="go-home-btn">
        Go to Home
      </button>
    </mat-card-content>
  </mat-card>
</div>

<app-footer></app-footer>
